import PortfolioShow from "../../../components/sections/portfolioShow";
import Head from "next/head"

export default function DocumentalFamilia() {
  return (
    <>
      <Head>
        <title>Sara Fontoura - Fotografia Documental de Família</title>
        <meta
          property="og:title"
          content="Sara Fontoura - Fotografia Documental de Família"
          key="title"
        />
        <meta
          property="og:description"
          content="Fotografia Documental de Família"
          key="ogdesc"
        />
      </Head>
      <PortfolioShow
        title="Documental de Família"
        subTitle="Fotografia Documental"
        folderPath="fotos/documental/documental_familia"
        mainPhotoUrl="/fotos/documental/documental_familia/DSC09373.webp"
        photoAlt="Documental de Familia - Fotografia Documental"
      >
        <p className="mb-2">
          Eventos e acontecimentos do cotidiano podem-se tornar verdadeiras
          obras de arte quando fotografadas no momento certo.
        </p>
        <p className="mb-2">
          Procuro com a fotografia documental registar de forma artística
          acontecimentos do cotidiano, para que os possa viver recordando-os
          sempre que quiser.
        </p>
      </PortfolioShow>
    </>
  )
}